import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/AuthProvider';
import { RestApi } from '../../services/rest-api';
import { useForm } from 'react-hook-form';
import { IField } from '../../interfaces/field.interface';
import { baseURL } from '../../constants/config';
import Form from 'react-bootstrap/Form';
import { Button, Col, Row } from 'react-bootstrap';
import { Fields } from '../../components/Fields';
import { useUtility } from '../../contexts/UtilityContext';

const Login: React.FC = () => {

  const navigate = useNavigate()

  const fields: Array<IField> = [
    {
      label: "Username",
      required: true,
      props: {
        name: "username",
        type: "text",
        inputMode: "text",
        placeholder: "Enter your username",
      }
    }, {
      label: "Password",
      required: true,
      props: {
        name: "password",
        type: "password",
        inputMode: "text",
        placeholder: "Enter Password"
      }
    }
  ];

  const { control, register, handleSubmit } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange"
  });
  const { authLogin } = useAuth();
  const { showLoader, hideLoader, alert } = useUtility();

  const onSubmit = handleSubmit(async (inputs) => {
    showLoader();
    RestApi('POST', 'login', inputs).then((response: any) => {
      hideLoader();
      authLogin(response.user);
      navigate(`${baseURL}dashboard`);
    }).catch((message) => {
      hideLoader();
      alert(message);
    });
  });

  return (
    <Form onSubmit={onSubmit} noValidate>
      <Row>
        <Col><h3 className="text-center">Log in Now</h3></Col>
      </Row>      
      <p className="text-center">Fill the form to log in</p>
      <Fields fields={fields} control={control} register={register} floating />      
      <Button variant='primary' type="submit" className="w-100">Log In</Button>
    </Form>
  );
};
export default Login;
